import { createAction, props } from '@ngrx/store';

export const OpenSidenav = createAction('[Administration: User Management]: Sidenav Opened');

export const CloseSidenav = createAction('[Administration: User Management]: Sidenav Closed');

export const UpdateUser = createAction(
  '[Administration: User Management]: Update User',
  props<{ row: any }>(),
);
